export const getCurrencySign = (code) => {
  // € $ ₴ ₽
  switch (code) {
    case "USD": return "$";
    case "EUR": return "€";
    case "UAH": return "₴";
    case "RUB": return "₽";
    default: break;
  }
};